"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "radda-in-chianti": {
    "2e3c65cd": [{
      "hkey": "f008c5b1",
      "slug": "badia-a-montemuro",
      "name": "Badia a Montemuro",
      "primary": true,
      "skipSearch": false
    }],
    "badia-montemuro": [{
      "hkey": "f008c5b1",
      "slug": "badia-a-montemuro",
      "name": "Badia a Montemuro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6d446e33": [{
      "hkey": "e4a2305c",
      "slug": "radda-in-chianti",
      "name": "Radda in Chianti",
      "primary": true,
      "skipSearch": false
    }],
    "monterinaldi": [{
      "hkey": "e4a2305c",
      "slug": "radda-in-chianti",
      "name": "Radda in Chianti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;